<template>
    <layout theme="white" class="binding-mobile-wrapper">
        <div class="binding-mobile-form">
            <div class="form-item">
                <div class="label">+86</div>
                <div class="input-wrapper">
                    <input class="input" v-model="mobileForm.mobile"  type="number" placeholder="请输入手机号码">
                </div>
            </div>
<!--            <div class="form-item captcha">-->
<!--                <div class="label">验证码</div>-->
<!--                <div class="input-wrapper">-->
<!--                    <input class="input" type="text" placeholder="请输入验证码">-->
<!--                </div>-->
<!--                <div class="get-captcha">获取验证码</div>-->
<!--            </div>-->
        </div>
        <div class="submit-button-wrapper"><button class="submit-button" @click="handleBindMobile">提 交</button></div>
    </layout>
</template>

<script>
    import {mapMutations} from 'vuex'
    export default {
        name: "BindingMobile",
        data() {
            return {
                mobileForm: {
                    mobile: undefined
                }
            }
        },
        methods: {
            handleBindMobile() {
                let mobile = this.mobileForm.mobile;
                mobile = mobile ? mobile.trim() : null;
                if (!mobile) {
                    this.$toast.fail('请输入手机号');
                }else if (!/^1(3([0-35-9]\d|4[1-8])|4[14-9]\d|5([0125689]\d|7[1-79])|66\d|7[2-35-8]\d|8\d{2}|9[89]\d)\d{7}$/.test(mobile)) {
                    this.$toast.fail('手机号格式不正确');
                } else {
                    this.netBindMobile(mobile);
                }
            },

            encryptMobile(mobile) {
                return mobile.substring(0, 3) + '******' + mobile.substring(mobile.length - 2);
            },

            onBindSuccess() {
                this.$router.back();
            },

            async netBindMobile(mobile) {
                const toast = this.$toast.loading({
                    message: '请稍等...',
                    forbidClick: true,
                    duration: 0
                });
                try {
                    await this.$req.bindMobile({
                        mobile: mobile
                    });
                    this.setMobile(this.encryptMobile(mobile));
                    this.onBindSuccess();
                } catch (e) {
                    //TODO
                } finally {
                    toast.clear();
                }
            },

            ...mapMutations([
                'setMobile'
            ])
        },
    }
</script>